import type { BankAccount } from '@prisma/client'

export function fullBankAccount (b: BankAccount) {
  return `${b.bankAccountPrefix ? `${b.bankAccountPrefix}-` : ''}${b.bankAccount}/${b.bankCode}`
}
